import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { LsqDataSource } from '@lsq-frontend/angular-shared/api-service';
import { LifecycleAware, TabsConfig } from '@lsq-frontend/common-ui';
import {
    CurrencyCode,
    FacilityUtilizationLegacyResponse,
    Money
} from '@lsq-frontend/remote-services/financing-graphql';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { SupplyChainDirectBuyerAccountSharedService } from '../../supply-chain-direct-buyer-account-shared.service';
@LifecycleAware()
@Component({
    selector: 'facility-utilization-ft-tile',
    styleUrls: ['./facility-utilization-ft-tile.component.scss'],
    templateUrl: './facility-utilization-ft-tile.component.html',
    encapsulation: ViewEncapsulation.None
})
export class FacilityUtilizationFtTileComponent implements OnInit, OnDestroy {
    @Input() public earlyPaymentDataSource!: LsqDataSource<FacilityUtilizationLegacyResponse>;
    @Input() public flexTermDataSource!: LsqDataSource<FacilityUtilizationLegacyResponse>;

    public progressValueFt: number;
    public progressValueEp: number;
    public isLoading = true;
    public isPayLaterEnabledForBuyer$ = this._supplyChainAccountSharedService.isPayLaterEnabled$;

    public tabsConfig!: TabsConfig[];
    private readonly _flexTermFacilityLabel = this._i18n('FlexTerm');
    private readonly _earlyPaymentFacilityLabel = this._i18n('Early Payment');
    public activeTab$ = new BehaviorSubject<'Early Payment' | 'FlexTerm' | string>('Early Payment');

    public readonly activeDataSource$ = this.activeTab$.pipe(
        map((activeTab) => {
            return activeTab === this._flexTermFacilityLabel
                ? this.flexTermDataSource
                : this.earlyPaymentDataSource;
        })
    );
    public onlyEarlyPaid: boolean;
    public selectedAmountObservable: Observable<Money>;

    constructor(
        private _i18n: I18n,
        private _supplyChainAccountSharedService: SupplyChainDirectBuyerAccountSharedService
    ) {}

    public async ngOnInit(): Promise<void> {
        this.selectedAmountObservable = of({
            currencyCode: CurrencyCode.USD,
            cents: 0
        });
        this.flexTermDataSource.data$.subscribe((data) => {
            this.progressValueFt = (data.utilized.cents!! * 100) / data.limit.cents!!;
        });

        this.earlyPaymentDataSource.data$.subscribe((data) => {
            this.progressValueEp = (data.utilized.cents!! * 100) / data.limit.cents!!;
        });
    }

    public ngOnChanges(): void {
        this.isPayLaterEnabledForBuyer$.subscribe((isEnabled) => {
            this.onlyEarlyPaid = !isEnabled;
            if (isEnabled) {
                this.tabsConfig = [
                    { label: this._earlyPaymentFacilityLabel },
                    { label: this._flexTermFacilityLabel }
                ];
            } else {
                this.tabsConfig = [{ label: this._earlyPaymentFacilityLabel }];
            }
        });
    }
    public ngOnDestroy(): void {}
}
